import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 1 }

import { ref } from 'vue'
import { DcMessage } from '@dc-platform/dc-components'
import Modal from '@/hooks/modalType'
import CustomerArea from '@/components/CustomerArea'
import dataConfig from '@/views/marketing/commonEnum/dataConfig'
import { partnerActivityList, partnerActivityDelete } from '@/api/marketing/marketingManage'
import { useRoute } from 'vue-router'
import type { PartnerManage } from '@/typings/api/marketingManage'
import partnerActivityFrom from './partnerActivityFrom.vue'

const __default__ = { name: 'PartnerActivity' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  edit: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {

const route = useRoute()
const table = ref()
const loading = ref(false)
const partnerActivityRef = ref()

const view = ref(false)
const fetch = (params: object, callBack: (res: any) => void) => {
  if (route.query.id) {
    partnerActivityList({
      partnerId: route.query.id,
      ...params
    }).then((res) => {
      callBack(res)
    })
  }
}

// 新增
const handleAdd = () => {
  view.value = false
  partnerActivityRef.value.toggle({
    partnerId: route.query.id,
    partnerName: route.query.name
  })
}
// 查看
const handleDetail = (row: PartnerManage['partnerContact']) => {
  view.value = true
  partnerActivityRef.value.toggle({
    ...row,
    partnerName: route.query.name
  })
}
// 编辑
const handleEdit = (row: PartnerManage['partnerContact']) => {
  view.value = false
  partnerActivityRef.value.toggle({
    ...row,
    partnerName: route.query.name
  })
}
// 删除
const handleDelete = (row: PartnerManage['partnerContact']) => {
  Modal.delete({
    name: row.name,
    onOk() {
      partnerActivityDelete({ id: row.id }).then((res) => {
        table.value.delFetch()
        DcMessage.success('删除成功')
      })
    }
  })
}
const success = (type?: 'add' | 'edit') => {
  if (type === 'add') {
    table.value.search()
  } else {
    table.value.fetch()
  }
}
const columns = ref([
  {
    title: '活动名称',
    dataIndex: 'name'
  },
  {
    title: '活动时间',
    dataIndex: 'startTime'
  },
  {
    title: '活动区域',
    dataIndex: 'areaId'
  },
  {
    title: '活动费用',
    dataIndex: 'cost'
  },
  {
    title: '是否参加',
    dataIndex: 'joinFlag',
    dicData: dataConfig.joinFlag
  },
  {
    title: '活动效果评估',
    dataIndex: 'resultEvaluate'
  },
  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right',
    width: 140
  }
])

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_cos_table, {
      columns: columns.value,
      tableId: "fbuPartnerActivity",
      onFetch: fetch,
      ref_key: "table",
      ref: table
    }, {
      bodyCell: _withCtx(({ column, record, text }) => [
        (column.dataIndex === 'name')
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              type: "link",
              title: text,
              onClick: ($event: any) => (handleDetail(record))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(text), 1)
              ]),
              _: 2
            }, 1032, ["title", "onClick"]))
          : _createCommentVNode("", true),
        (column.dataIndex === 'startTime')
          ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(record.startTime) + "-" + _toDisplayString(record.endTime), 1))
          : _createCommentVNode("", true),
        (column.dataIndex === 'areaId')
          ? (_openBlock(), _createBlock(_unref(CustomerArea), {
              key: 2,
              type: "text",
              value: text
            }, null, 8, ["value"]))
          : _createCommentVNode("", true),
        (column.dataIndex === 'action')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "link",
                onClick: ($event: any) => (handleEdit(record))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 编辑 ")
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_permission, 'fbu_partner_activity_edit_btn']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "link",
                onClick: ($event: any) => (handleDelete(record))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 删除 ")
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_permission, 'fbu_partner_activity_del_btn']
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["columns"]),
    _createVNode(partnerActivityFrom, {
      ref_key: "partnerActivityRef",
      ref: partnerActivityRef,
      onSuccess: success,
      view: view.value
    }, null, 8, ["view"]),
    _createVNode(_component_cos_footer_button, {
      loading: loading.value,
      returnName: "DcCosZbuPartnerManage"
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_a_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (handleAdd())),
          loading: loading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode("新增市场活动")
          ]),
          _: 1
        }, 8, ["loading"])), [
          [_directive_permission, 'fbu_partner_activity_add_btn']
        ])
      ]),
      _: 1
    }, 8, ["loading"])
  ], 64))
}
}

})